import _get from "lodash/get";
import { RootState } from "../../../../../models";
import { Disclaimer } from "../../../../../models/state";

export type State = Pick<RootState, "disclaimers">;
export const getDisclaimers: (state: State) => Disclaimer[] | [] = (state) =>
    _get(state, "disclaimers.summaryDisclaimers", []);
